import React, { useEffect, useState } from 'react';

import { FormattedMessage } from 'react-intl';
import { Box, Chip } from '@mui/material';

import { ControlBox } from '../../../atoms/control-box';
import { useSelector } from '../../../store/utils';

export const SettingsPvInverterStatus = () => {
  const [lastCommunicationAt, setLastCommunicationAt] = useState<Date | null>(
    null
  );

  // trigger re-render every second
  const [, setTick] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setTick((t) => t + 1);
    }, 1_000);

    return () => clearInterval(interval);
  }, []);

  const [communicationOkCount] = useSelector(
    ({ variables }) =>
      [variables.PV_cnt_com_ok, variables.PV_INFO.Status] as const
  );

  const lastCommunicationCountRef = React.useRef(communicationOkCount);
  useEffect(() => {
    if (communicationOkCount !== lastCommunicationCountRef.current) {
      setLastCommunicationAt(new Date());
      lastCommunicationCountRef.current = communicationOkCount;
    }
  }, [communicationOkCount]);

  const communicationIsOk = lastCommunicationAt
    ? new Date().getTime() < lastCommunicationAt.getTime() + 10_000
    : false;

  return (
    <ControlBox
      title={
        <FormattedMessage
          id="settings.inverter_communication_status"
          defaultMessage="Komunikace se střídačem"
        />
      }
      subtitle={
        <FormattedMessage
          id="settings.inverter_communication_status.subtitle"
          defaultMessage="Navázání komunikace může trvat několik desítek vteřin až pár minut"
        />
      }
      control={
        <Chip
          label={
            <Box>
              {communicationIsOk ? (
                <FormattedMessage
                  id="settings.inverter_communication_status.ok"
                  defaultMessage="Komunikace navázána{br}({count} čtení)"
                  values={{
                    count: communicationOkCount < 0 ? 0 : communicationOkCount,
                    br: <br />,
                  }}
                />
              ) : (
                <FormattedMessage
                  id="settings.inverter_communication_status.not_ok"
                  defaultMessage="Nenavázána,{br}pokouším se o spojení..."
                  values={{ br: <br /> }}
                />
              )}
            </Box>
          }
          color={communicationIsOk ? 'success' : 'error'}
          sx={{
            fontSize: '0.7rem',
            py: 0.5,
            height: 'auto',
            mb: { xs: 1, sm: 0 },
            mt: -1,
          }}
          size="medium"
        />
      }
      visibility={{ variableId: 'PV_INSTALL' }}
      fullWidth
    />
  );
};
